import React from 'react';
import { SectionPlaceholder } from '../Placeholders/SectionPlaceholder';
import { ItemCardPlaceholder } from '../Placeholders/ItemCardPlaceholder';

interface SkeletonLoadersProps {
  loading?: boolean;
}

export const SkeletonLoaders: React.FC<SkeletonLoadersProps> = ({
  loading = true
}) => {
  if (!loading) return null;
  return (
    <SectionPlaceholder isCardsLayout>
      {Array.from({ length: 4 }, (_, index) => (
        <ItemCardPlaceholder key={index} isCardsLayout />
      ))}
    </SectionPlaceholder>
  );
};
